import React from 'react';
import ReactDOM from 'react-dom/client';
import ManageOrganization from './ManageOrganization';
import store from './store';
import { Provider } from 'react-redux';
import AddOrganization from './AddOrganization';

if (document.getElementById('manage-organization')) {
  ReactDOM.createRoot(document.getElementById('manage-organization')).render(
    <Provider store={store}>
      <React.StrictMode>
        <ManageOrganization />
      </React.StrictMode>
    </Provider>,
  );
}

if (document.getElementById('add-organization')) {
  const addOrganization = document.getElementById('add-organization');
  const preCheckout = addOrganization.dataset;
  const checkoutUrl = addOrganization.dataset.checkoutUrl;
  console.log(checkoutUrl);
  console.log(preCheckout);
  ReactDOM.createRoot(addOrganization).render(
    <Provider store={store}>
      <React.StrictMode>
        <AddOrganization preCheckout={preCheckout} checkoutUrl={checkoutUrl} />
      </React.StrictMode>
    </Provider>,
  );
}
